let initId;
let fixTextId;
let counterInit = 0;
let counterFixText = 0;


let init = function () {

    if (window.sessionStorage.getItem('cmp-consent-state') === '1'){
        clearInterval(initId)
    }

    console.log('%c CMP modal not set ' + counterInit, 'background: #672675; color: #ffffff');

    // element present in clickio cmp modal
    let denyButton = document.querySelector("button.cl-consent__close-link");
    let consentButton = document.querySelector("a.cl-consent__btn[data-role='b_agree']");
    let consentModal = document.getElementById('cl-consent');

    counterInit++;
    if (counterInit > 50 || (denyButton && window.sessionStorage.getItem('cmp-consent-state') === '-1')) {
        clearInterval(initId)
    }

    if (!denyButton){
        return;
    }

    clearInterval(initId);
    // add deterrent button
    let span = '<span id="dismiss-deterrent">Continua senza accettare</span>'
    denyButton.insertAdjacentHTML('afterend', span);

    let deterrentElement = document.querySelector('#dismiss-deterrent');

    // user click on deterrent
    deterrentElement.addEventListener('click', function (event) {

        let deterrentModal = document.getElementById('deterrent-modal');

        if (deterrentModal) {

            deterrentModal.removeAttribute('hidden');
            consentModal.setAttribute('hidden', 'hidden');
            return;
        }

        let modal = `
            <div class="deterrent-modal" id="deterrent-modal">
                <div id="deterrent-back" >
                    &larr; Torna indietro
                </div>
                <div class="deterrent-content">
                    <h1>Maggiori informazioni</h1>
                    <p>Se accetti <u>“tutti i cookie”</u>, compresi quelli di profilazione, oltre a sostenere <u>la nostra offerta gratuita</u>, riceverai annunci pubblicitari in linea con i tuoi interessi.</p>
                    <p>Se invece accetti solo i cookie “strettamente necessari” riceverai pubblicità generalista di cui non saranno limitati il numero e la ripetizione.</p>
                    <div class="deterrent-choice">
                        <div id="deterrent-no" class="deterrent-button deny">Accetta cookie strettamente necessari</div>
                        <div id="deterrent-yes" class="deterrent-button accept">Accetta tutti i cookie</div>
                    </div>
                </div>
            </div>`;
        document.body.insertAdjacentHTML('beforeend', modal);

        if (consentModal) {
            consentModal.setAttribute('hidden', 'hidden');
        }

        // user accept
        document.getElementById('deterrent-yes').addEventListener('click', function (event) {

            let evt = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });

            document.getElementById('deterrent-modal').setAttribute('hidden', 'hidden');
            consentButton.dispatchEvent(evt);
        });

        // user deny
        document.getElementById('deterrent-no').addEventListener('click', function (event) {

            let evt = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });

            document.getElementById('deterrent-modal').setAttribute('hidden', 'hidden');
            denyButton.dispatchEvent(evt);
        });

        // user click to back
        document.getElementById('deterrent-back').addEventListener('click', function (event) {

            let deterrentModal = document.getElementById('deterrent-modal');
            deterrentModal.setAttribute('hidden', 'hidden');
            consentModal.removeAttribute('hidden');
        });

    });
}


let fixText = function () {

    if (window.sessionStorage.getItem('cmp-consent-state') === '1'){
        clearInterval(fixTextId)
    }

    console.log('%c CMP fix text non set ' + counterFixText, 'background: #312675; color: #ffffff');
    counterFixText++;
    if (counterFixText > 50) {
        clearInterval(fixTextId)
    }

    let consentDescription = document.querySelector("[id='cl-consent'] > div > div > div.cl-consent__descr p:last-child");

    if (consentDescription) {
        let p = document.createElement('p');
        p.innerHTML = 'Puoi modificare le tue preferenze in qualsiasi momento ritornando su questo sito o consultando la nostra <a href="https://m.calciomercato.com/about/informativa-cookie">informativa cookie</a> e/o <a href="https://m.calciomercato.com/about/privacy">informativa sulla riservatezza</a>';
        consentDescription.appendChild(p);
        clearInterval(fixTextId)
    }
}


initId = setInterval(init, 1000);
fixTextId = setInterval(fixText, 1000);
